import React from 'react'
import {useLocation} from 'react-router-dom'
import LandingPage from './LandingPage'
import ShortToLongUrl from './ShortToLongUrl'

const WrapperPage = () => {
  const location = useLocation()

  return location?.pathname?.[1] == 'l' && location?.pathname?.split('-')?.length == 1 ? (
    <LandingPage />
  ) : (
    <ShortToLongUrl />
  )
}

export default WrapperPage
